const MakeTuple = <T extends string[]>(...args: T) => args;
export default MakeTuple;
